import React from "react";
import "../CustomCSS/Specialities.css";

const specialitiesData = [
  { imgSrc: "img/specialities/weight.jpg", title: "Weight Management" },
  { imgSrc: "img/specialities/pain.jpg", title: "Pain Management" },
  { imgSrc: "img/specialities/depression.jpg", title: "Depression & Anxiety" },
  { imgSrc: "img/specialities/detox.jpg", title: "Body Detoxification" },
  { imgSrc: "img/specialities/gastric.jpg", title: "Gastric Problems" },
  { imgSrc: "img/specialities/immunity.jpg", title: "Immunity" },
  { imgSrc: "img/specialities/mentalhealth.jpg", title: "Mental Health" },
  { imgSrc: "img/specialities/skin.jpg", title: "Skin & Hair Care" },
];

const Specialities = () => {
  return (
    <section className="specialities-section" id="specialities">
      <h2 className="specialities-title">Our Specialities</h2>
      <div className="specialities-grid">
        {specialitiesData.map(({ imgSrc, title }, idx) => (
          <div className="speciality-card" key={idx}>
            <div className="speciality-image-wrapper">
              <img src={imgSrc} alt={title} className="speciality-image" />
            </div>
            <h3 className="speciality-title">{title}</h3>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Specialities;
